export enum sidebarTypes {
    TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR",
  }
  
export default sidebarTypes;
  